<template>
	
<div class="density" :class="{'is-active': active && score}">

	<div class="density-title">{{ section.density.title }}</div>

	<div class="density-scale">

		<div class="density-scale-score" v-if="score !== false">

			<div :style="{left: scoreLeft}"><small>Your T Score</small><span>{{ scoreText }}</span></div>

		</div>

		<div class="density-scale-values">
			<div>0</div>
			<div>-1</div>
			<div>-2</div>
			<div>-3</div>
			<div>-4</div>
		</div>

		<div class="density-scale-labels">
			<div>Normal</div>
			<div>Low Bone Density</div>
			<div>Osteoporosis</div>
		</div>

	</div>

	<com-next v-if="!completed" v-on:click.native="$emit('next')" class="density-next" />

</div>

</template>

<script>

import comNext from './../common/Next'

export default {

	props: ['section', 'active', 'completed'],

	components: {
		'com-next': comNext
	},

	watch: {

		active: function() {

			if (!this.score) this.$emit('next')

		}

	},

	computed: {

		score: function() {

			var score = this.$store.getters['session/values'][this.section.density.variable]
			
			return (score === null) ? false : parseFloat(score).toFixed(1)

		},

		scoreLeft: function() {

			var points = {
				'0': 5,
				'-0': 5,
				'-1': 76,
				'-2': 147,
				'-3': 217,
				'-4': 287
			}

			var parts = this.score.toString().split('.')

			var left = 0

			var original = parts[0]

			if (parts[0] > 0) parts[0] = 0
			if (parts[0] < -4) parts[0] = -4

			left = points[parts[0]]

			var increment = (this.score > 0) ? -1 : 1

			if (parts[1] !== '0' && original <= 0 && original >= -3) {

				left += ((points[(parseInt(parts[0]) - increment).toString()] - left) / 10) * parseInt(parts[1])

			}

			return left + 'px'

		},

		scoreText: function() {

			return this.score.toString()
		
		}

	}
	
}

</script>

<style scoped>

.density {
	width: 50%;
	height: 297px;
	background-color: var(--aid-color);
	border-bottom-left-radius: 48px;
	padding: 30px;
	filter: grayscale(100%);
	opacity: 0.25;
	transition: all 300ms linear;
}

.density.is-active {
	opacity: 1;
	filter: grayscale(0%);
}

.density-title {
	color: #343434;
	font-size: 18px;
	letter-spacing: 1px;
	font-weight: 600;
	text-transform: uppercase;
	margin-bottom: 40px;
}

.density-title:after {
	content: ' ';
	display: block;
	position: absolute;
	height: 2px;
	width: 75px;
	bottom: -10px;
	background-color: #fff;
}

.density-scale {
	width: 359px;
	height: 43px;
	position: absolute;
	top: 160px;
	background-image: url(~@/assets/aid/risk/density/scale.svg);
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.density-scale-values {
	width: 100%;
	position: absolute;
	top: -8px;
	font-size: 12px;
	display: flex;
	flex-direction: row;
	font-weight: 600;
	color: #343434;
}

.density-scale-values div:nth-child(1) { margin-left: 34px; width: 64px; }
.density-scale-values div:nth-child(2) { width: 76px; }
.density-scale-values div:nth-child(3) { width: 70px; }
.density-scale-values div:nth-child(4) { width: 70px; }

.density-scale-labels {
	width: 100%;
	position: absolute;
	top: 48px;
	font-size: 12px;
	display: flex;
	flex-direction: row;
	font-weight: 600;
	color: #343434;
	align-items: center;
}

.density-scale-labels div {
	text-align: center;
	padding: 0px 10px;
}

.density-scale-labels div:nth-child(1) { margin-left: 30px; width: 72px; }
.density-scale-labels div:nth-child(2) { width: 114px; border-left: 2px dashed #3FB194; border-right: 2px dashed #3FB194; }
.density-scale-labels div:nth-child(3) { width: 110px; }

.density-scale-score {
	position: absolute;
	top: -24px;
	left: 32px;
	width: 296px;
	height: 1px;
}

.density-scale-score div {
	position: absolute;
	bottom: 0px;
	margin-left: -55px;
	width: 111px;
	height: 75px;
	background-color: #343434;
	border-radius: 16px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	color: #fff;
	font-weight: 600;
}

.density-scale-score div small {
	font-size: 12px;
	margin-bottom: 4px;
	letter-spacing: 1px;
}

.density-scale-score div span {
	font-size: 35px;
	letter-spacing: 2px;
}

.density-scale-score div:after {
	content: ' ';
	position: absolute;
	width: 20px;
	height: 10px;
	background-color: #343434;
	bottom: -9px;
	left: 50%;
	margin-left: -10px;
	clip-path: polygon(0px 0px, 100% 0px, 50% 100%);
}

.density-next {
	position: absolute;
	bottom: 15px;
	right: 60px;
}

</style>